/**
 * OVERRIDE ImageGallery.jsx
 * REASON: To implement Title, Description and Copyright info.
 */

import ImageGallery from '../../../../../../components/Blocks/Listing/ImageGallery';

export default ImageGallery;
